// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TicketFormInfo from "../../../ticket-dashboard/app/tickets/entities/TicketFormInfo.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(basicOrderJson) {
  return DeccoUtils$Catalyst.resolveResult(TicketFormInfo.t_decode(basicOrderJson), "BasicOrderStateMapper.re");
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
